var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// @ts-ignore
import EventBus from '@EventBus';
import { mapGetters, mapActions } from "vuex";
import { ACCOUNT_CHECKOUT, LOCATION, CART, ACCOUNT } from "@/stores/defs";
import { EServiceType } from "@/models/interfaces/Orders/EServiceType";
import { getServiceTypeName } from "@/utils/helper.functions";
import { EPreorder } from "@/services/order.service";
import { isEmpty, find } from 'lodash';
import accountMixin from '@Mixin/accountMixin';
import serviceMixin from '@Mixin/serviceMixin';
import locationsMixin from '@Mixin/locationsMixin';
var checkoutMixin = {
    mixins: [
        accountMixin,
        serviceMixin,
        locationsMixin,
    ],
    data: function () {
        return {
            EServiceType: EServiceType,
            errorObject: null,
        };
    },
    computed: __assign({}, mapGetters({
        checkoutTotal: CART.GET_CHECKOUT_TOTAL,
        deliveryAddress: ACCOUNT_CHECKOUT.GET_DELIVERY_ADDRESS,
        itemCount: CART.ITEM_COUNT,
        cartItems: CART.ITEMS,
        cartCoupon: CART.GET_COUPON,
        cartPrice: CART.PRICE,
        location: LOCATION.GET_LOCATION,
        minimumDelivery: LOCATION.GET_MIN_DELIVERY,
        orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME,
        paymentMethod: ACCOUNT_CHECKOUT.GET_PAYMENT_METHOD,
        preorder: ACCOUNT_CHECKOUT.GET_PREORDER,
        orderInFlight: ACCOUNT_CHECKOUT.GET_ORDER_IN_FLIGHT,
        serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
        customer: ACCOUNT.GET_CUSTOMER,
        guestName: ACCOUNT.GET_GUEST_NAME,
        guestPhone: ACCOUNT.GET_GUEST_PHONE,
        guestEmail: ACCOUNT.GET_GUEST_EMAIL,
        isGuest: ACCOUNT_CHECKOUT.GET_IS_GUEST,
        userInstructions: ACCOUNT_CHECKOUT.GET_USER_INSTRUCTIONS,
        totals: CART.GET_TOTALS
    }), { isCheckoutDisabled: function () {
            if (this.orderInFlight) {
                return true;
            }
            if (this.underDeliveryMinimum()) {
                return true;
            }
            if (this.missingInformation()) {
                return true;
            }
            if (EServiceType.SERVICE_TYPE_DELIVERY === this.serviceType) {
                if (!this.deliveryAddress || (!this.paymentMethod && this.preorder === EPreorder.PAY_NOW) || !this.itemCount) {
                    return true;
                }
            }
            else if (EServiceType.SERVICE_TYPE_TAKEOUT === this.serviceType) {
                if (!this.location || !this.itemCount || (this.preorder === EPreorder.PAY_NOW && !this.paymentMethod)) {
                    return true;
                }
            }
            else if (!this.serviceType) {
                return true;
            }
            if (!this.orderTime || this.deliveryFee === false) {
                return true;
            }
            return false;
        },
        deliveryFee: function () {
            // only use the delivery price in address if location does region checking
            if (this.deliveryAddress &&
                this.deliveryAddress.delivery.isDeliverable &&
                this.deliveryAddress.delivery.price &&
                this.location.hasDeliveryRegionsSet) {
                if (!this.deliveryAddress.delivery.price) {
                    return false;
                }
                return this.deliveryAddress.delivery.price;
            }
            else {
                return this.location.delivery.baseDeliveryFee;
            }
        },
        validCheckoutUser: function () {
            var guest = this.isGuest;
            var guestId = guest && this.guestId;
            var customer = this.customer;
            var customerId = customer && customer.id;
            if (guestId || customerId) {
                return true;
            }
            return false;
        } }),
    methods: __assign({}, mapActions({
        setCartItems: CART.SET_ITEMS,
        setCoupon: CART.SET_COUPON,
        setOrderInFlight: ACCOUNT_CHECKOUT.SET_ORDER_IN_FLIGHT,
        setTotals: CART.SET_TOTALS,
    }), { clearStateAfterOrder: function () {
            this.setCoupon(null);
        },
        underDeliveryMinimum: function () {
            if (this.serviceType === EServiceType.SERVICE_TYPE_DELIVERY) {
                var totals = this.totals;
                var preTaxSubTotal = totals.subTotal - totals.discount;
                return (this.minimumDelivery >= preTaxSubTotal);
            }
            return false;
        }, getServiceTypeName: getServiceTypeName, getCustomerName: function () {
            var guest = this.isGuest;
            var name = '';
            if (!isEmpty(this.guestName)) {
                name = " (" + this.guestName + ")";
            }
            if (guest) {
                return "Guest" + name;
            }
            var customer = this.customer;
            if (customer.id) {
                return customer.printFullName();
            }
        },
        missingInformation: function () {
            if (this.isGuest) {
                var requirements = [
                    {
                        name: 'phone number',
                        pass: this.hasValidPhone(this.guestPhone)
                    },
                    {
                        name: 'name',
                        pass: this.hasValidName(this.guestName)
                    },
                    {
                        name: 'email',
                        pass: this.hasValidEmail(this.guestEmail)
                    },
                ];
                var missingRequirement = find(requirements, function (requirement) {
                    var missing = (requirement.pass !== 'success');
                    return missing;
                });
                if (missingRequirement) {
                    var parseErrorObject = JSON.stringify(this.errorObject);
                    var newErrors = JSON.stringify(missingRequirement);
                    if (parseErrorObject !== newErrors) {
                        this.errorObject = missingRequirement;
                        EventBus.$emit('form-invalid-alert', this.errorObject);
                    }
                    return true;
                }
                return false;
            }
            if (!this.customer.phone) {
                return true;
            }
            return false;
        },
        checkValidForm: function () {
            if (this.isCheckoutDisabled) {
                EventBus.$emit('show-errors');
            }
        },
        totalsForCheckout: function () {
            var totals = this.totals;
            if (this.isForDelivery) {
                var fee = this.location.delivery.baseDeliveryFee;
                this.totals.serviceCharge = fee;
                this.setTotals(this.totals); // TODO cleanup contracts with API
            }
            else {
                this.totals.serviceCharge = 0;
            }
            return totals;
        } }),
};
export default checkoutMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/checkoutMixin.ts
// module id = fuwv
// module chunks = 18